// extracted by mini-css-extract-plugin
export var baseForm = "_redotech-redo-return-app-src-login-common-base-form";
export var error = "_redotech-redo-return-app-src-login-common-error";
export var formFields = "_redotech-redo-return-app-src-login-common-form-fields";
export var giftFields = "_redotech-redo-return-app-src-login-common-gift-fields";
export var loadingSpinner = "_redotech-redo-return-app-src-login-common-loading-spinner";
export var nameFields = "_redotech-redo-return-app-src-login-common-name-fields";
export var spinnerContainer = "_redotech-redo-return-app-src-login-common-spinner-container";
export var title = "_redotech-redo-return-app-src-login-common-title";